import { emptyValueForSchema, getSchemaAt, CASE_TYPE_SCHEMA } from "../../../../case-spec";
import {
  ArrayShell,
  PeopleSelect,
  RowCard,
  useOpenIndex,
} from "../shared-ui";
import {
  asArray,
  isRecord,
  peopleNames,
  str,
  type PanelProps,
} from "../shared";
import {
  appendAtPath,
  childPath,
  getAtPath,
  setAtPath,
} from "../path-utils";

const PATH = "canon.relationships";

export function RelationshipsPanel({
  root,
  disabled,
  onChangeRoot,
}: PanelProps) {
  const items = asArray(getAtPath(root, PATH));
  const names = peopleNames(root);
  const { openIndex, setOpenIndex, toggle } = useOpenIndex(items.length);
  const itemSchema = getSchemaAt(CASE_TYPE_SCHEMA, "canon.relationships[0]");

  return (
    <ArrayShell
      title="关系"
      count={items.length}
      disabled={disabled}
      onAdd={() => {
        const row = itemSchema
          ? emptyValueForSchema(itemSchema)
          : { from: names[0] ?? "", to: names[1] ?? "" };
        onChangeRoot(appendAtPath(root, PATH, row));
        setOpenIndex(items.length);
      }}
    >
      <ul className="flex flex-col gap-2">
        {items.map((item, index) => {
          const rec = isRecord(item) ? item : {};
          const itemPath = childPath(PATH, index);
          const title = `${str(rec.from)} → ${str(rec.to)}`;
          return (
            <RowCard
              key={itemPath}
              title={title.trim() ? title : `关系 ${index + 1}`}
              open={openIndex === index}
              onToggle={() => toggle(index)}
              disabled={disabled}
              index={index}
              total={items.length}
              arrayPath={PATH}
              root={root}
              onChangeRoot={onChangeRoot}
            >
              <PeopleSelect
                label="从"
                value={str(rec.from)}
                names={names}
                disabled={disabled}
                allowEmpty
                onChange={(v) =>
                  onChangeRoot(setAtPath(root, childPath(itemPath, "from"), v))
                }
              />
              <PeopleSelect
                label="到"
                value={str(rec.to)}
                names={names}
                disabled={disabled}
                allowEmpty
                onChange={(v) =>
                  onChangeRoot(setAtPath(root, childPath(itemPath, "to"), v))
                }
              />
            </RowCard>
          );
        })}
      </ul>
    </ArrayShell>
  );
}
